module.exports = __webpack_public_path__ + "media/audio124.28f9e83f.mp3";